<app-menu headerCSS="header-transparent"></app-menu>
<section class="header-inner header-inner-big bg-holder text-white"
    style="background-image: url(assets/images/bg/banner-01.jpg);">
    <job-filter></job-filter>
</section>
<section class="space-ptb">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <!--=================================
        left-sidebar -->
                <div class="sidebar">
                    <div class="widget">
                        <div class="widget-title widget-collapse">
                            <h6>Where</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#jobLocation" role="button"
                                aria-expanded="true" aria-controls="jobLocation"> <i class="fas fa-chevron-down"></i>
                            </a>
                        </div>
                        <div class="collapse " id="jobLocation">
                            <div class="widget-content pl-1">
                                <div class="search pb-1">
                                    <i class="fas fa-search" (click)="handleLocationSearch()"></i>
                                    <input type="text" class="form-control" placeholder="City"
                                        [(ngModel)]="jobFilter.locationFilter.city"
                                        (keyup.enter)="handleLocationSearch()">
                                </div>
                                <div class="search pb-1">
                                    <i class="fas fa-search" (click)="handleLocationSearch()"></i>
                                    <input type="text" class="form-control" placeholder="Country"
                                        [(ngModel)]="jobFilter.locationFilter.country"
                                        (keyup.enter)="handleLocationSearch()">
                                </div>
                                <div class="form-row pb-2 pl-2 pt-3">
                                    <div class="custom-control custom-checkbox pr-5">
                                        <input type="checkbox" class="custom-control-input" id="radio_remote"
                                            name="workType" (change)="handleWorkTypeFilter(0)" [(ngModel)]="workRemote">
                                        <label class="custom-control-label text-dark"
                                            for="radio_remote">{{locationTypes.REMOTE}}</label>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="radio_onsite"
                                            name="workType" (change)="handleWorkTypeFilter(1)" [(ngModel)]="workOnSite">
                                        <label class="custom-control-label text-dark"
                                            for="radio_onsite">{{locationTypes.ON_SITE}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="widget">
                        <div class="widget-title widget-collapse">
                            <h6>Date Posted</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#dateposted" role="button"
                                aria-expanded="false" aria-controls="dateposted"> <i class="fas fa-chevron-down"></i>
                            </a>
                        </div>
                        <div class="collapse " id="dateposted">
                            <div class="widget-content">
                                <div class="custom-control custom-checkbox">
                                    <input #dateposted type="checkbox" class="custom-control-input"
                                        (click)="onDatePostedPeriodClicked($event, 0)" id="dateposted-0">
                                    <label class="custom-control-label" for="dateposted-0">Last 24 hour</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #dateposted type="checkbox" class="custom-control-input"
                                        (click)="onDatePostedPeriodClicked($event, 3)" id="dateposted-3">
                                    <label class="custom-control-label" for="dateposted-3">Last 3 days</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #dateposted type="checkbox" class="custom-control-input"
                                        (click)="onDatePostedPeriodClicked($event, 7)" id="dateposted-7">
                                    <label class="custom-control-label" for="dateposted-7">Last 7 days</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #dateposted type="checkbox" class="custom-control-input"
                                        (click)="onDatePostedPeriodClicked($event, 14)" id="dateposted-14">
                                    <label class="custom-control-label" for="dateposted-14">Last 14 days</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="widget widget-scrollable">
                        <div class="widget-title widget-collapse">
                            <h6>Specialism</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#specialism" role="button"
                                aria-expanded="false" aria-controls="specialism"> <i class="fas fa-chevron-down"></i>
                            </a>
                        </div>
                        <div class="collapse " id="specialism" *ngFor="let sector of (lookupStore.sectors | async)">
                            <div class="widget-content">
                                <div class="custom-control custom-checkbox">
                                    <input #jobsector type="checkbox" class="custom-control-input"
                                        (click)="onSectorClicked($event, sector.id)" id="sector-{{sector.id}}">
                                    <label class="custom-control-label"
                                        for="sector-{{sector.id}}">{{sector.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="widget widget-scrollable">
                        <div class="widget-title widget-collapse">
                            <h6>Job Type</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#job_type" role="button"
                                aria-expanded="false" aria-controls="job_type"> <i class="fas fa-chevron-down"></i> </a>
                        </div>
                        <div class="collapse " id="job_type"
                            *ngFor="let job_Type of (lookupStore.jobTypes | async)">
                            <div class="widget-content">
                                <div class="custom-control custom-checkbox">
                                    <input #jobType type="checkbox" class="custom-control-input"
                                        (click)="onJobTypeClicked($event, job_Type.id)" id="jobType-{{job_Type.id}}">
                                    <label class="custom-control-label"
                                        for="jobType-{{job_Type.id}}">{{job_Type.value}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="widget widget-scrollable">
                        <div class="widget-title widget-collapse">
                            <h6>Experience</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#experience" role="button"
                                aria-expanded="false" aria-controls="experience"> <i class="fas fa-chevron-down"></i>
                            </a>
                        </div>
                        <div class="collapse " id="experience">
                            <div class="widget-content">
                                <div class="custom-control custom-checkbox">
                                    <input #experience type="checkbox" class="custom-control-input" id="experience-1"
                                        (click)="onExperienceClicked($event,1)">
                                    <label class="custom-control-label" for="experience-1">at least 1 Year</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #experience type="checkbox" class="custom-control-input" id="experience-2"
                                        (click)="onExperienceClicked($event,2)">
                                    <label class="custom-control-label" for="experience-2">at least 2 Year</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #experience type="checkbox" class="custom-control-input" id="experience-3"
                                        (click)="onExperienceClicked($event,3)">
                                    <label class="custom-control-label" for="experience-3">at least 3 Year</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #experience type="checkbox" class="custom-control-input" id="experience-4"
                                        (click)="onExperienceClicked($event,4)">
                                    <label class="custom-control-label" for="experience-4">at least 4 Year</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input #experience type="checkbox" class="custom-control-input" id="experience-5"
                                        (click)="onExperienceClicked($event,5)">
                                    <label class="custom-control-label" for="experience-5">at least 5 Year</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="widget widget-scrollable">
                        <div class="widget-title widget-collapse">
                            <h6>Salary</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#Offeredsalary" role="button"
                                aria-expanded="false" aria-controls="Offeredsalary"> <i class="fas fa-chevron-down"></i>
                            </a>
                        </div>
                        <div class="collapse " id="Offeredsalary">
                            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                                <li [ngbNavItem]="1">
                                    <a ngbNavLink>Annual</a>
                                    <ng-template ngbNavContent>
                                        <div class="custom-control custom-checkbox"
                                            *ngFor="let annualSalary of annualSalaries">
                                            <input #salary type="checkbox" class="custom-control-input"
                                                id="salary-{{annualSalary}}"
                                                (click)="onSalaryRangeClicked($event, 'Annual', annualSalary)">
                                            <label class="custom-control-label" for="salary-{{annualSalary}}">at
                                                least
                                                ${{annualSalary}}</label>
                                        </div>
                                    </ng-template>
                                </li>
                                <li [ngbNavItem]="2">
                                    <a ngbNavLink>Daily</a>
                                    <ng-template ngbNavContent>
                                        <div class="widget-content">
                                            <div class="custom-control custom-checkbox"
                                                *ngFor="let dailySalary of dailySalaries">
                                                <input #salary type="checkbox" class="custom-control-input"
                                                    id="salary-{{dailySalary}}"
                                                    (click)="onSalaryRangeClicked($event,'Daily', dailySalary)">
                                                <label class="custom-control-label" for="salary-{{dailySalary}}">at
                                                    least
                                                    ${{dailySalary}}</label>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                                <li [ngbNavItem]="3">
                                    <a ngbNavLink>Hourly</a>
                                    <ng-template ngbNavContent>
                                        <div class="widget-content">
                                            <div class="custom-control custom-checkbox"
                                                *ngFor="let hourlySalary of hourlySalaries">
                                                <input #salary type="checkbox" class="custom-control-input"
                                                    id="salary-{{hourlySalary}}"
                                                    (click)="onSalaryRangeClicked($event, 'Hourly', hourlySalary)">
                                                <label class="custom-control-label" for="salary-{{hourlySalary}}">at
                                                    least
                                                    ${{hourlySalary}}</label>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                            <div [ngbNavOutlet]="nav" class="mt-2"></div>
                        </div>
                    </div>
                    <hr>
                    <div class="widget widget-scrollable">
                        <div class="widget-title widget-collapse">
                            <h6>Qualification</h6>
                            <a class="ml-auto" data-toggle="collapse" href="#qualification" role="button"
                                aria-expanded="false" aria-controls="qualification"> <i
                                    class="fas fa-chevron-down"></i></a>
                        </div>
                        <div class="collapse " id="qualification">
                            <div class="widget-content">
                                <div class="custom-control custom-checkbox"
                                    *ngFor="let educationLevel of (lookupStore.educationLevels | async)">
                                    <input #qualification type="checkbox" class="custom-control-input"
                                        (click)="onEducationLevelClicked($event, educationLevel.id)"
                                        id="educationLevel-{{educationLevel.id}}">
                                    <label class="custom-control-label"
                                        for="educationLevel-{{educationLevel.id}}">{{educationLevel.value}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-9">
                <!--=================================
                      right-sidebar -->
                <div class="job-filter mb-4 d-sm-flex align-items-center">
                    <div class="job-shortby ml-sm-auto d-flex align-items-center">
                        <form class="form-inline">
                            <div class="form-group mb-0">
                                <label class="justify-content-start mr-2">Sort By :</label>
                                <div class="short-by">
                                    <select class="form-control basic-select" (change)="onSortOrderChanged($event)">
                                        <option value="0">Recent</option>
                                        <option value="1">Oldest</option>
                                        <option value="2">Lowest Salary</option>
                                        <option value="3">Highest Salary</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row" *ngIf="showFilteringJobs">
                    <div class="col-12">
                        Filtering jobs.....
                    </div>
                </div>
                <div class="row" *ngIf="!showFilteringJobs && jobs.length == 0">
                    <div class="col-12">
                        No jobs found
                    </div>
                </div>
                <div class="row" *ngFor="let job of jobs">
                    <div class="col-12">
                        <div class="job-list">
                            <div class="job-list-logo">
                                <img class="img-fluid" [src]="job.businessLogo" alt="">
                            </div>
                            <div class="job-list-details">
                                <div class="job-list-info">
                                    <div class="job-list-title">
                                        <h5 class="mb-0"><a
                                                routerLink="/view-job/{{job.id}}/search-jobs">{{job.title}}</a></h5>
                                    </div>
                                    <div class="job-list-option">
                                        <ul class="list-unstyled">
                                            <li><i class="fas fa-map-marker-alt pr-1"></i>{{job.city}}, {{job.country}}
                                            </li>
                                            <li><i class="fas fa-filter pr-1"></i>{{job.sector}}</li>
                                            <li><a class="freelance" href="#"><i
                                                        class="fas fa-suitcase pr-1"></i>{{job.type}}</a></li>
                                            <li><a class="freelance" href="#"><i
                                                        class="fas flaticon-debit-card pr-1"></i>{{job.salaryRange}}</a>
                                            </li>
                                            <li *ngIf="job.applied == true" class="notice">
                                                You have already applied for this job on {{job.applicationDate | date:
                                                'mediumDate'}}
                                            </li>
                                        </ul>
                                        <span class="description">
                                            {{job.description}}
                                        </span>
                                    </div>
                                </div>
                                <div class="job-list-info col pt-2 pl-0">
                                  <div class="job-list-option">
                                      <ul class="list-unstyled">
                                          <li *ngIf="job.totalAmountSpent"><i
                                            class="fas fa-money pr-1" title="Total Spent"></i>${{job.totalAmountSpent}} spent
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                            </div>
                            <div class="job-list-favourite-time"> <a class="job-list-favourite order-2"
                                    [ngClass]="{bookmarked: job.bookmarked === true}" [routerLink]=""
                                    (click)="onFavouriteClicked(job.id)"><i class="far fa-heart"></i></a> <span
                                    class="job-list-time order-1"><i class="far fa-clock pr-1"></i>{{job.expiry}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showPager">
                    <pager [totalPageCount]="pageCount" (valueChange)="onPagerValueChanged($event)"></pager>
                </div>
            </div>
        </div>
    </div>
</section>